import React from 'react'
import cx from 'clsx'

import * as styles from './Sketch.module.scss'

const Sketch = ({ className, primary, ...props }) => (
  <svg
    className={cx([styles.sketch, primary && styles.sketchPrimary, className])}
    viewBox="0 0 595.255 595.282"
    fill="currentColor"
    {...props}
  >
    <path d="M86.8 99c-20.5 0-37.2 16.7-37.2 37.2v99.2h24.8V136.2c0-6.8 5.6-12.4 12.4-12.4h297.6V99H86.8z" />
    <path d="M86.8 471.1c-6.8 0-12.4-5.6-12.4-12.4V334.7H49.6v124c0 20.5 16.7 37.2 37.2 37.2h124v-24.8H86.8z" />
    <path d="M393.2 503.1L92 201.9c-4.8-4.8-12.7-4.8-17.5 0L3.6 272.7c-4.8 4.8-4.8 12.7 0 17.5L304.8 591.5c2.3 2.3 5.5 3.6 8.8 3.6 3.3 0 6.4-1.3 8.8-3.6l70.9-70.9C398 515.8 398 507.9 393.2 503.1zM313.6 565.2L29.9 281.5l53.3-53.3 283.7 283.7L313.6 565.2z" />
    <path d="M545.7 471.1H359.6v24.8h136.4v62c0 6.9 5.6 12.4 12.4 12.4h37.2c27.4 0 49.6-22.2 49.6-49.6S573.1 471.1 545.7 471.1zM545.7 545.5h-24.8V495.9h24.8c13.7 0 24.8 11.1 24.8 24.8S559.4 545.5 545.7 545.5z" />
    <path d="M545.7 99h-62v24.8h62c13.7 0 24.8 11.1 24.8 24.8v372.1h24.8V148.6C595.3 121.2 573.1 99 545.7 99z" />
    <rect
      x="190.7"
      y="365.7"
      transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 637.8103 491.9656)"
      width="52.6"
      height="24.8"
    />
    <rect
      x="141.1"
      y="316.1"
      transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 518.0508 442.355)"
      width="52.6"
      height="24.8"
    />
    <rect
      x="240.3"
      y="415.3"
      transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 757.5295 541.5814)"
      width="52.6"
      height="24.8"
    />
    <rect
      x="289.9"
      y="464.9"
      transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 877.3464 591.2152)"
      width="52.6"
      height="24.8"
    />
    <rect
      x="91.5"
      y="266.5"
      transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 398.2334 392.7672)"
      width="52.6"
      height="24.8"
    />
    <path d="M534.9 27.7L517.8 10.6c-14.5-13.8-37.3-13.8-51.8 0l-188.6 188.6c-4.8 4.8-4.8 12.7 0 17.5l51.4 51.4c2.3 2.3 5.5 3.6 8.8 3.6 3.3 0 6.4-1.3 8.8-3.6L534.9 79.5c0 0 0 0 0 0C549.2 65.2 549.2 42 534.9 27.7zM517.4 62L337.6 241.8l-33.9-33.9L483.5 28.1c4.7-4.5 12.1-4.5 16.7 0l17.2 17.1c0 0 0 0 0 0C522 49.9 522 57.4 517.4 62z" />
    <path d="M333.6 247.6l-53.5 17.9 17.9-53.6 -23.6-7.9 -25.7 77.2c-0.4 1.3-0.6 2.6-0.6 3.9 0 6.9 5.6 12.4 12.4 12.4 1.3 0 2.6-0.2 3.9-0.6l77.2-25.7L333.6 247.6z" />
    <rect
      x="453.7"
      y="43"
      transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 851.8468 -194.2)"
      width="24.8"
      height="72.7"
    />
    <rect x="260.4" y="272.7" width="186" height="24.8" />
    <rect x="471.3" y="272.7" width="24.8" height="24.8" />
    <rect x="520.9" y="272.7" width="24.8" height="24.8" />
  </svg>
)

export { Sketch }
